'use client';
import React, { useEffect, useState } from 'react';
import { Link, withRouter } from '#/renderer/router';
import { useHookstate } from '@hookstate/core';
import $ from 'jquery';

import ModalNotification from '~/components/ui/ModalNotification';

import { validateRenewal } from '~/helpers/validate_form';
import useStores from '~/store/StoreHook';
import ModalNotificationToken from '~/components/ui/ModalNotificationToken';
import '~/sass/modules/_renewal.scss';
//import blukai, removido
// import json from './json.json'
import '~/sass/modules/_contract.scss';
import { useConfigMC } from '~/store/Query/api';
import { clearNumber, useRenewalState, validation1, validation2 } from '~/store/States/renewal';
import IconInfoCircle from '~/components/renewal/IconInfo';
import AlertBillExample from '~/components/renewal/AlertBillExample';
import Notification from './Notification/Notification.ui';
import SetMetatags from '~/containers/Views/SetMetatags';
import analyticsRenewal from '~/helpers/analytics-renewal';

const Modal = (props) => (
  <ModalNotification>
    <div className="text-center my-5 my-md-0 ModalRenewal">
      <nav>
        <button type="button" className="red-color btn-close" onClick={props.close}>
          <span>
            <i className="fas fa-times-circle fa-2x" />
          </span>
        </button>
      </nav>
      <img src={props.modalIcon} alt="" />
      <h1>{props.modalTitle}</h1>
      <p dangerouslySetInnerHTML={{ __html: props.message }} />
      {props.modalLink?.indexOf('http') === 0 ? (
        <a
          href={props.modalLink}
          className="btn btn-lg btn-danger mb-3 botonModal1"
          target="_blank"
          rel="noopener noreferrer nofollow"
        >
          {props.modalBtnText}
        </a>
      ) : (
        <Link to={{ pathname: props.modalLink || '#' }} className="btn btn-lg btn-danger mb-3 botonModal1">
          {props.modalBtnText}
        </Link>
      )}
    </div>
  </ModalNotification>
);

const Token = ({ closePopups, handleChangeToken, tokenReenviar, handleSubmitToken, error, isPostPago,
  title, description, btnText, resend, modalTokenPlaceholder }) => {
  const message = (
    <div className="align-button">
      <button type="button" className="btn" data-bs-dismiss="modal" aria-label="Close" onClick={closePopups}>
        <i className="fas fa-times red-text" />
      </button>
    </div>
  );
  return (
    <ModalNotificationToken>
      {message}
      <section className="modal--content-validate-number modalToken">
        <h2>{title}</h2>
        <header>
          <p dangerouslySetInnerHTML={{ __html: description }} />
        </header>
        <form name="validateToken" onSubmit={handleSubmitToken}>
          {isPostPago
            ? (
              <label htmlFor="token">
                <input
                  id="token"
                  name="token"
                  type="text"
                  className="inputTokenValido"
                  autoComplete="off"
                  onChange={handleChangeToken}
                />
              </label>
            )
            : (
              <div className="mb-3">
                <input
                  type="text"
                  placeholder={modalTokenPlaceholder}
                  className="form-control inputCode"
                  onChange={handleChangeToken}
                  required
                  minLength={8}
                  maxLength={30}
                />
              </div>
            )}
          {error && <Notification title={error} />}
          <button className="red-claro-btn FirstBtn" type="submit">
            <span>{btnText}</span>
          </button>
          {isPostPago && (
            <button className="red-claro-btn secondBtn" type="button" onClick={tokenReenviar}>
              <span>{resend}</span>
            </button>
          )}
        </form>
      </section>
    </ModalNotificationToken>
  );
};

const Renewal2 = (props) => {
  const { data } = useConfigMC();
  const { orderStore } = useStores();
  const [message, setMessage] = useState(null);
  const [displayModal, setDisplayModal] = useState(false);
  const [displayTokenModal, setDisplayTokenModal] = useState(false);
  const [modalLink, setModalLink] = useState(null);
  const [modalBtnText, setmodalBtnText] = useState(null);
  const [modalTitle, setModalTitle] = useState(null);
  const [modalIcon, setModalIcon] = useState(null);
  const [error, setError] = useState(null);
  const [queryGenerateToken, setQueryGenerateToken] = useState(null);

  const [stateDisplayAlert, setStateDisplayAlert] = useState(-1);

  const [modalTokenBtnText, setmodalTokenBtnText] = useState(null);
  const [modalTokenTitle, setModalTokenTitle] = useState(null);
  const [modalTokenDescription, setModalTokenDescription] = useState(null);
  const [modalTokenResend, setModalTokenResend] = useState(null);
  const [modalTokenPlaceholder, setModalTokenPlaceholder] = useState(null);

  const [errorToken, setErrorToken] = useState(null);
  const [token, setToken] = useState(null);
  const [lineOfBusiness, setLineOfBusiness] = useState(null);
  const [isPostPago, setIsPostPago] = useState(null);
  const renewalState = useRenewalState();
  const state = useHookstate(renewalState.texto);
  const phoneNumber = useHookstate('');

  const [redirectTokenEmail, setRedirectTokenEmail] = useState('');
  const [showBillingExample, setShowBillingExample] = useState(false);
  const [messageModalPayment, setMessageModalPayment] = useState('');
  const [messageAgreementExpired, setMessageAgreementExpired] = useState('');
  const [facturasPermitidas, setFactPermitidas] = useState('');
  const [ metaTagsConfig, setMetaTagsConfig ] = useState({ show: false, title: '', description: '', path: '' });

  useEffect(() => {
    validateRenewal();
  }, []);
  useEffect(() => {
    setMetaTagsDynamically(data);
  }, [data]);
  useEffect(() => {
    if (data && data.ok) {
      if (data.body.redirectTokenEmail) {
        setRedirectTokenEmail(data.body.redirectTokenEmail);
      }
      setFactPermitidas(data.body.numberoverdueBillsAllowed);
    }
  }, [data]);

  // useeffect to update the status when I call the modal
  useEffect(() => {
    switch (stateDisplayAlert) {
      case 0:
        setMessage(messageModalPayment);
        // setMessage(state.renewals_modal_payment_description.value);
        setModalTitle(state.renewals_modal_payment_title.value);
        setModalLink(state.renewals_modal_payment_btnLink.value);
        setmodalBtnText(state.renewals_modal_payment_btnMesssage.value);
        setModalIcon(state.renewals_modal_payment_icon.value);
        setDisplayTokenModal(false);
        break;
      case 1:
        setMessage(messageAgreementExpired);
        setModalTitle(state.renewals_modal_agreementExpired_title.value);
        setModalLink(state.renewals_modal_agreementExpired_btnLink.value);
        setmodalBtnText(state.renewals_modal_agreementExpired_btnMesssage.value);
        setModalIcon(state.renewals_modal_agreementExpired_icon.value);
        setDisplayTokenModal(false);
        break;
      case 2:
        setMessage(state.renewals_modal_nonClaro_description.value);
        setModalTitle(state.renewals_modal_nonClaro_title.value);
        setModalLink(state.renewals_modal_nonClaro_btnLink.value);
        setmodalBtnText(state.renewals_modal_nonClaro_btnMesssage.value);
        setModalIcon(state.renewals_modal_nonClaro_icon.value);
        break;
      case 4:
        setMessage(state.renewals_modal_prepago_description.value);
        setModalTitle(state.renewals_modal_prepago_title.value);
        setModalLink(state.renewals_modal_prepago_btnLink.value);
        setmodalBtnText(state.renewals_modal_prepago_btnMesssage.value);
        setModalIcon(state.renewals_modal_prepago_icon.value);
        break;
      case 5:
        setMessage(state.renewals_modal_paymentNew_description.value);
        setModalTitle(state.renewals_modal_paymentNew_title.value);
        setModalLink(state.renewals_modal_payment_redirect.value);
        setmodalBtnText(state.renwals_modal_button_continue.value);
        setModalIcon(state.renewals_modal_payment_icon.value);
        setDisplayTokenModal(false);
        break;
      case 6:
        setMessage(state.renewals_modal_payment_error_description.value);
        setModalTitle(state.renewals_modal_payment_title.value);
        setModalLink(state.renewals_modal_payment_btnLink.value);
        setmodalBtnText(state.renewals_modal_payment_btnMesssage.value);
        setModalIcon(state.renewals_modal_payment_icon.value);
        setDisplayTokenModal(false);
        break;
      case 7:
        setMessage(messageAgreementExpired);
        setModalTitle(state.renewals_modal_validation_title.value);
        setModalLink(state.renewals_modal_validation_btn_link.value);
        setmodalBtnText(state.renewals_modal_validation_btn_message.value);
        setModalIcon(state.renewals_modal_validation_icon.value);
        setDisplayTokenModal(false);
        break;
      default:
        break;
    }
  }, [stateDisplayAlert, displayModal]);

   /**
   * The function sets meta tags dynamically based on a given configuration.
   * @param config - an object containing information about the response from an API call, including a
   * body property with metadata information.
   * @returns a boolean value. It returns `true` if the `config` object has a truthy `ok` property,
   * `metaTagsConfigList` exists and has a property with the key `path`, `title` and `description`
   * properties exist in `metaTagsConfig`, and a new object `newMetaTagsConfig` is successfully created
   * and passed to the `setMetaTagsConfig` function. It returns `false` otherwise.
   */
   const setMetaTagsDynamically = (config) => {

    try {

      const path = 'renewals'

      if (config?.ok === true) {

        const metaTagsConfigList = config.body['metatag_titulos_categorias']

        if (!metaTagsConfigList) {
          return false;
        }

        const metaTagsConfig = metaTagsConfigList[path] ?? null;

        if (!metaTagsConfig) {
          return;
        }

        const title = metaTagsConfig.title ?? null;
        const description = metaTagsConfig.description ?? null;

        if (!title || !description) {

          return false;

        }

        const newMetaTagsConfig = {
          show: true,
          title,
          description,
          path
        }

        setMetaTagsConfig(newMetaTagsConfig)

        return true;

      }

      return false;

    } catch (error) {
      return false;
    }

  }

  const storageData = () => {
    if (isPostPago) {
      sessionStorage.setItem('renewals.phonePostPago', phoneNumber.value);
      sessionStorage.setItem('renewals.isPostPago', isPostPago);
    } else {
      sessionStorage.setItem('renewals.phoneHouse', phoneNumber.value);
      sessionStorage.setItem('renewals.phoneBill', token);
      sessionStorage.setItem('renewals.isPostPago', isPostPago);
    }
    props.history.push('/renewals-plan');
  };

  const generateToken = (lob, number) => {
    const queryGenerarToken = {
      generarToken: {
        UserProfileID: redirectTokenEmail,
        MobileNumber: number,
        LineOfBusiness: lob,
      },
    };
    //AQUI VALIDAR SI HAY QUE USAR ESTE METODO, O USAR EL TOKEN STATICO DEL MS
    if (data.body.isToken) { //si es true validar el token estatico del MC, entonces no se envia al telefono
      setLineOfBusiness(lob);
      setDisplayTokenModal(true);
      setDisplayModal(false);
      setQueryGenerateToken(queryGenerarToken);
    } else {
      orderStore.generarToken(queryGenerarToken).then((resultGT) => {
        if (resultGT.success) {
          const responseGT = resultGT.data.data.generarToken || resultGT.data.data.generarTokenResponse;
          if (responseGT && responseGT.AcknowledgementIndicator === 'SUCCESS') {
            setLineOfBusiness(lob);
            setDisplayTokenModal(true);
            setDisplayModal(false);
            setQueryGenerateToken(queryGenerarToken);
          } else {
            setError('Ha ocurrido un error, intente más tarde.');
          }
        } else {
          setError('Ha ocurrido un error, intente más tarde.');
        }
      });
    }
  };

  const sendData = async (e) => {
    e.preventDefault();
    setError(null);
    clearNumber();
    const $form = $("form[name='renewal']");
    if ($form.valid()) {
      phoneNumber.set($('input[name=numRequest]', $form).val().replace('-', ''));
      const result = await validation1(
        true,
        phoneNumber.value,
        orderStore,
        generateToken,
        null,
        state,
      );

      setLineOfBusiness(result.lob);
      sessionStorage.setItem('renewals.lob', result.lob);

      setModalTokenDescription(result.modalTokenDescription);
      setModalTokenTitle(result.modalTokenTitle);
      setmodalTokenBtnText(result.modalTokenBtnText);
      setModalTokenPlaceholder(result.modalTokenPlaceholder);
      setIsPostPago(result.isPostPago);
      setDisplayTokenModal(result.displayTokenModal);
      setDisplayModal(result.displayModal);
      setModalTokenResend(result.modalTokenResend);
      setStateDisplayAlert(result.displayAlert);
      setError(result.error);
    }
  };

  const tokenReenviar = (e) => {
    e.preventDefault();
    setErrorToken('');

    if (data.body.isToken) { //si es true validar el token estatico del MC, entonces no se envia al telefono
      setDisplayTokenModal(true);
      setDisplayModal(false);
    } else {
      orderStore.generarToken(queryGenerateToken).then((resultGT) => {
        if (resultGT.success) {
          const responseGT = resultGT.data.data.generarToken || resultGT.data.data.generarTokenResponse;
          //console.log(responseGT);
          if (responseGT && responseGT.AcknowledgementIndicator === 'SUCCESS') {
            setDisplayTokenModal(true);
            setDisplayModal(false);
          } else {
            setError('Ha ocurrido un error, intente más tarde.');
          }
        } else {
          setError('Ha ocurrido un error, intente más tarde.');
        }
      });
    }
  };

  const closeModal = () => {
    setDisplayModal(false);
    setErrorToken('');
    setDisplayTokenModal(false);
  };

  const closePopups = () => {
    closeModal();
  };

  const handleChangeToken = (e) => {
    setToken(e.target.value);
  };

  const validateToken = async () => { //valida token
    setErrorToken('');
    const queryValidarToken = {
      validarToken: {
        UserProfileID: redirectTokenEmail,
        MobileNumber: phoneNumber.value,
        LineOfBusiness: lineOfBusiness,
        Token: token,
      },
    };
    if (data.body.isToken) {
      if (token === data.body.valueToken) {
        await onValidate();
      } else {
        setErrorToken(state.modal_token_error.value);
      }
    } else {
      orderStore.validarToken(queryValidarToken).then(async (resultVT) => {
        if (resultVT.success) {
          const responseVT = resultVT.data.data.validarToken || resultVT.data.data.validarTokenResponse;
          if (responseVT && responseVT.AcknowledgementIndicator === 'SUCCESS') {
            await onValidate();
          } else {
            setErrorToken(state.modal_token_error.value);
          }
        }
      });
    }
  };

  const onValidate = async () => {
    const result = await validation2(
      true,
      isPostPago,
      phoneNumber.value,
      token,
      lineOfBusiness,
      data.body.numberBillHistory,
      +facturasPermitidas,
      storageData,
      state,
    );

    setMessageModalPayment(result.modalPayment);
    setStateDisplayAlert(result.displayAlert);
    setDisplayModal(result.displayModal);
    setMessageAgreementExpired(result.agreementExpired);
    setErrorToken(result.errorToken);
  };

  const handleSubmitToken = async (e) => {

    //EVENT_ANALYTIC: Click_Botton_Reno_Confirmar_Pin
    analyticsRenewal.confirmRenoPin();
    e.preventDefault();
    if (sessionStorage.getItem('renewals.mock')) {
      storageData();
      return;
    }
    if (isPostPago) {
      validateToken();
    } else {
      await onValidate();
    }
  };

  const showExampleBillId = () => {
    setShowBillingExample(!showBillingExample);
  };

  return (
    <main className="has-bootstrap">

      {/* <Metatags name="Renovaciones" /> */}
      {
        metaTagsConfig.show && (
          <SetMetatags
            title={metaTagsConfig.title}
            description={metaTagsConfig.description}
          />
        )
      }
      <section className="renewal">
        <div className="container">
          <div className="row text-center mt-1">
            <div className="row text-center mt-1 roboto-bold" />
            <div className="col-lg-2 col-mb-2 col-sm-1" />
            <div className="col-lg-8 col-mb-8 col-sm-10 contPrincipal">
              <form className="form-cont" name="renewal" action="" method="POST" onSubmit={sendData}>
                <img className="icoHoja" src={`${process.env.NEXT_PUBLIC_ESPOTS}/renovacion_fijos_movil/Contrato.png`} alt="" />
                <h2 className="titleForm1">{state.pantalla_principal_titulo.value}</h2>
                <span className="textForm1">{state.pantalla_principal_descripcion.value}</span>
                <div className="mb-3 input-renewal-container">
                  <input type="text" name="numRequest" placeholder={state.pantalla_principal_placeholder.value} className="form-control" required minLength={2} maxLength={11} inputMode="numeric" pattern="[0-9]*" />
                  <IconInfoCircle src={state.pantalla_principal_info_icono.value} onClick={() => showExampleBillId()} />
                </div>
                <button type="submit" onClick={() => {
                  //blukai function, removida
                }} className="btn btn-lg btn-danger mb-3 buttonForm1">{state.pantalla_principal_boton.value}</button>
                {error ? <Notification title={error} /> : null}
              </form>
            </div>
          </div>
        </div>
        {displayModal && (
          <Modal
            message={message}
            modalTitle={modalTitle}
            modalBtnText={modalBtnText}
            modalLink={modalLink}
            modalIcon={modalIcon}
            close={closeModal}
          />
        )}
        {displayTokenModal && (
          <Token
            closePopups={closePopups}
            handleChangeToken={handleChangeToken}
            tokenReenviar={tokenReenviar}
            handleSubmitToken={handleSubmitToken}
            error={errorToken}
            isPostPago={isPostPago}
            title={modalTokenTitle}
            description={modalTokenDescription}
            btnText={modalTokenBtnText}
            resend={modalTokenResend}
            modalTokenPlaceholder={modalTokenPlaceholder}
          />
        )}
      </section>
      {
        showBillingExample && (
          <AlertBillExample
            close={showExampleBillId}
            imageBilling={state.renewals_modal_billing_image.value}
            descriptionBilling={state.renewals_modal_billing_description.value}
          />
        )
      }
    </main>
  );
};

export default withRouter(Renewal2);
